import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import AuthShell from '../components/auth/AuthShell';

const VerifyEmployee = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setMessage('No verification token provided');
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/employee/verify-employee?token=${token}`
        );
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Employee verification failed');
        setMessage(data.message || 'Employee account verified successfully!');
        setIsSuccess(true);
        setTimeout(() => navigate('/login'), 3000);
      } catch (error) {
        setMessage(error.message || 'Failed to verify employee account');
        setIsSuccess(false);
      } finally {
        setIsLoading(false);
      }
    };

    verifyToken();
  }, [searchParams, navigate]);

  return (
    <AuthShell title="Account Verification" subtitle="Verifying your employee account...">
      <div className="flex flex-col items-center text-center py-6">
        {isLoading ? (
          <>
            <div className="spinner mb-4" />
            <p className="text-gray-600 dark:text-gray-400">Verifying your employee account...</p>
          </>
        ) : (
          <>
            <div
              className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
                isSuccess
                  ? 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600'
                  : 'bg-red-100 dark:bg-red-900/30 text-red-600'
              }`}
            >
              {isSuccess ? <FaCheckCircle className="w-8 h-8" /> : <FaExclamationCircle className="w-8 h-8" />}
            </div>
            <p
              className={`text-sm font-medium mb-6 ${
                isSuccess ? 'text-emerald-700 dark:text-emerald-400' : 'text-red-700 dark:text-red-400'
              }`}
            >
              {message}
            </p>
            {isSuccess ? (
              <p className="text-xs text-gray-500 dark:text-gray-400">Redirecting to login...</p>
            ) : (
              <Link to="/login" className="btn-premium px-6 py-2.5 text-sm">
                Go to Login
              </Link>
            )}
          </>
        )}
      </div>
    </AuthShell>
  );
};

export default VerifyEmployee;
